
























































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const couponModule = namespace("coupon");

@Component
export default class auditCouponList extends Vue {
  private businessEntityGroupList: Array<any> = [];
  private list: Array<any> = []; // 券列表
  private total: number = 0; // 券总条数
  private currentPage: number = 1; // 当前页
  private shopGroupDisabled: Boolean = false; // 店铺组是否禁止筛选
  private timePickShow: Boolean = false; // 日期picker
  private couponListLoading: Boolean = false; // 列表loadding
  private ListOnloadFinished: Boolean = false; // 全部加载完成loadding
  private isLoading: Boolean = false; // 下拉loadding
  private currtTime: any = new Date(); // 日期picker 当前时间
  private filter: any = {
    // 筛选条件
    searchVal: "",
    searchTime: "",
    shopGroup: "",
    couponStatus: ""
  };

  // 券状态下拉
  private couponStatusOptions: Array<Object> = [
    { text: "全部", value: "" },
    { text: "待审核", value: 20 },
    { text: "投放中", value: 30 },
    { text: "已驳回", value: 10 }, // 也即：已驳回 ==> 已创建
    { text: "已禁用", value: 50 },
    { text: "已结束", value: 60 }
  ];

  defaultImg = require("@/image/default.png");

  mounted() {
    this.getBusinessEntityGroup();
    this.getCouponList();
  }
  /**
   * 店铺组
   */
  async getBusinessEntityGroup(pageNum: number = 1, pageSize: number = 1000) {
    const { error, success } = await this.$store.dispatch(
      "coupon/getBusinessEntityGroupList",
      {
        pageNum,
        pageSize
      }
    );
    if (success) {
      const arr: any = [];
      success.data.list.map((item: any) => {
        arr.push({
          text: item.businessEntityGroupEntityName,
          value: item.businessEntityGroupId,
          ...item
        });
      });
      if (arr.length == 1) {
        this.shopGroupDisabled = true;
        this.filter["shopGroup"] = arr[0].value;
      } else {
        arr.unshift({ text: "全部", value: "", entityIds: [] });
      }
      this.businessEntityGroupList = arr;
    }
  }
  /**
   * get 券列表
   */
  async getCouponList(pageNum: number = 1, pageSize: number = 10) {
    this.couponListLoading = true;
    const filteredArr = this.businessEntityGroupList.filter(
      item => item.value == this.filter["shopGroup"]
    );
    const businessEntityIdList = filteredArr.length
      ? filteredArr[0].entityIds
      : [];
    const { error, success } = await this.$store.dispatch(
      "coupon/getCouponNewList",
      {
        businessEntityIdList,
        couponActivityBusinessEntityId: this.$global.tenantId,
        // couponName: this.filter["searchVal"] || null,
        couponNameOrActivityName: this.filter["searchVal"] || null,
        putInDate: this.filter["searchTime"],
        couponStatus: this.filter["couponStatus"],
        pageNum,
        pageSize
      }
      // {
      //   businessEntityIdList,
      //   businessEntityId: this.$global.tenantId,
      //   // couponName: this.filter["searchVal"] || null,
      //   couponNameOrActivityName: this.filter["searchVal"] || null,
      //   activityStartDate: this.filter["searchTime"],
      //   couponStatus: this.filter["couponStatus"],
      //   pageNum,
      //   pageSize
      // }
    );
    this.couponListLoading = false;
    this.isLoading = false;
    if (success) {
      this.list = [...this.list, ...success.data.list];
      this.total = success.data.total;
      if (this.list.length >= success.data.total) {
        this.ListOnloadFinished = true;
      }
    }
  }
  /**
   * search input 键盘确定、失去光标时搜索
   */
  onSearch() {
    this.list = [];
    this.initData();
    this.getCouponList(1, 10);
  }
  /**
   * 上拉触发onload 加载下一页
   */
  handleCouponPage() {
    this.currentPage++;
    this.getCouponList(this.currentPage, 10);
  }
  /**
   * 下拉刷新
   */
  onRefresh() {
    this.initData();
    this.getCouponList(1, 10);
  }
  /**
   * 日期picker 确认
   */
  dateTimeSure(selectDate: any) {
    const year = selectDate.getFullYear();
    const month = selectDate.getMonth() + 1;
    const day = selectDate.getDate();
    this.filter["searchTime"] = `${year}-${month < 10 ? `0${month}` : month}-${
      day < 10 ? `0${day}` : day
    }`;
    this.timePickShow = false;
    this.initData();
    this.getCouponList();
  }
  /**
   * 店铺组 change
   */
  handleShopGroupChange(value: any) {
    this.filter["shopGroup"] = value;
    this.initData();
    this.getCouponList(1, 10);
  }
  /**
   * 券状态 change
   */
  handleCouponStatusChange(value: any) {
    this.filter["couponStatus"] = value;
    this.initData();
    this.getCouponList(1, 10);
  }
  /**
   * 跳转至详情
   */
  goToCouponDetails(id: any, couponBatchId: any) {
    // this.$router.push(`/coupon/audit/details/${id}`);
    this.$router.push({
      path: `/coupon/audit/details`,
      query: { id, couponBatchId }
    });
  }
  /**
   * 券状态 样式
   */
  renderStatusStyle(status: number) {
    switch (status) {
      case 30:
        return "#09BB07";
        break;
      case 10:
        return "#9B9B9B";
        break;
      case 20:
        return "#F92E93";
        break;
      default:
        return "#F76260";
        break;
    }
  }
  /**
   * 初始化 列表、当前页、list组件finished
   */
  initData() {
    this.list = [];
    this.currentPage = 1;
    this.ListOnloadFinished = false;
  }
}
